const prizeConstants = {
    checkingOrder: 'CHECKING_ORDER',
    completed: 'COMPLETED',
    reject: 'REJECT',
    approved: 'APPROVED',
    mailSent: 'MAIL_SENT',
}

export default prizeConstants;